<script setup lang="ts">
  interface Props {
    modelValue: string;
    maxLength?: number;
    maxValue?: number;
    isContinuous?: boolean;
  }

  const modelValue = defineModel<string>();
  const props = withDefaults(defineProps<Props>(), {
    maxLength: undefined,
    maxValue: undefined,
    isContinuous: true,
  });

  // 키 넘버 목록
  const keyList = ['1', '2', '3', '4', '5', '6', '7', '8', '9', 'C', '0'];

  const emits = defineEmits(['keypadClick']);

  const handleClickKeypad = (keyValue: string) => {
    if (props.isContinuous) {
      if (keyValue === 'C') {
        modelValue.value = '';
      } else if (keyValue === 'B') {
        modelValue.value = props.modelValue.length > 1 ? props.modelValue.slice(0, props.modelValue.length - 1) : '';
      } else {
        let newValue = `${props.modelValue}${keyValue}`;
        if (props.maxLength && newValue.length > props.maxLength) {
          newValue = props.modelValue;
        }
        if (props.maxValue && Number(newValue) > props.maxValue) {
          newValue = props.maxValue.toString();
        }
        modelValue.value = newValue;
      }
    } else {
      // 컴포넌트 외부에서 처리
      emits('keypadClick', keyValue);
    }
  };
</script>

<template>
  <div class="base-keypad">
    <button
      v-for="(key, index) in keyList"
      :key="index"
      class="keypad__number"
      @mouseup="handleClickKeypad(key)"
      @touchend.prevent="handleClickKeypad(key)"
    >
      {{ key }}
    </button>
    <button class="keypad__number" @mouseup="handleClickKeypad('B')" @touchend.prevent="handleClickKeypad('B')">
      <img src="@/assets/images/icon-backspace.svg" alt="지우기" />
    </button>
  </div>
</template>

<style scoped lang="scss">
  @use '@/assets/scss/variables' as vars;

  .base-keypad {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1.1194vw;
    width: 100%;
    height: 100%;
    @media (max-width: vars.$md) {
      gap: 10px;
    }
    .keypad__number {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 4.9254vw;
      font-size: 2.9851vw;
      font-weight: 500;
      border: 0.0746vw solid var(--border-color-primary);
      border-radius: 0.3731vw;
      background: #fbfbfb;
      @media (max-width: vars.$sm) {
        font-size: 24px;
      }
      img {
        width: 3.077vw;
        @media (max-width: vars.$sm) {
          width: 24px;
        }
      }
    }
  }
</style>
